<sup *ngIf="!hasLabel"><i class="fa fa-question-circle-o" enTooltip data-toggle="tooltip" data-placement="top" title="{{tooltipTitle}}"></i></sup>
<span *ngIf="hasLabel" enTooltip data-toggle="tooltip" data-placement="top" title="{{tooltipTitle}}">{{label}}</span>
